<script setup>
import { useI18n } from 'vue-i18n'
import TitleComponent from "@/components/TitleComponent/index.vue"
const { t } = useI18n();
import { useRouter } from 'vue-router'
const router = useRouter()
const goBack = () => {
    router.go(-1);
}
const isMobile=ref(false);//false代表pc
onMounted(() => { 
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
})
</script>
<template>
<div class="container">
    <TitleComponent v-if="isMobile" :title="t('setup135')"></TitleComponent>

   
    <div class="packContent">
    <div class="title">
        {{ $t('setup135') }}
    </div>
    <div class="Headline">{{ $t('setup224') }}</div>
    <div class="Headline">{{ $t('setup225') }}</div>
    <div class="content">
        <div class="Subtitle-title">
            {{ $t('setup226') }}
        </div>
        <p class="Subtitle-content">{{ $t('setup227') }}</p>
    </div>
    <div class="content">
        <div class="Subtitle-title">
            {{ $t('setup228') }}
        </div>
        <p class="Subtitle-content">{{ $t('setup229') }}</p>
        <p class="Subtitle-content">{{ $t('setup230') }}</p>
        <p class="Subtitle-content">{{ $t('setup231') }}</p>
        <p class="Subtitle-content">{{ $t('setup232') }}</p>
        <p class="Subtitle-content">{{ $t('setup233') }}</p>
    </div>
    <div class="content">
        <div class="Subtitle-title">
            {{ $t('setup234') }}
        </div>
        <p class="Subtitle-content">{{ $t('setup235') }}</p>
        <p class="Subtitle-content">{{ $t('setup236') }}</p>
        <p class="Subtitle-content">{{ $t('setup237') }}</p>
    </div>
    <div class="content">
        <div class="Subtitle-title">
            {{ $t('setup238') }}
        </div>
        <p class="Subtitle-content">{{ $t('setup239') }}</p>
        <p class="Subtitle-content">{{ $t('setup240') }}</p>
        <p class="Subtitle-content">{{ $t('setup241') }}</p>
        <p class="Subtitle-content">{{ $t('setup242') }}<span>{{ $t('setup243') }}</span></p>
        <p class="Subtitle-content">{{ $t('setup244') }}</p>
        <p class="Subtitle-content">{{ $t('setup245') }}</p>
        <p class="Subtitle-content">{{ $t('setup246') }}</p>
        <p class="Subtitle-content">{{ $t('setup247') }}</p>
    </div>
    <div class="content">
        <div class="Subtitle-title">
            {{ $t('setup248') }}
        </div>
        <p class="Subtitle-content">{{ $t('setup249') }}</p>
       
    </div>
    <div class="content">
        <div class="Subtitle-title">
            {{ $t('setup250') }}
        </div>
        <p class="Subtitle-content">{{ $t('setup251') }}</p>
        <p class="Subtitle-content">{{ $t('setup252') }}</p>
        <p class="Subtitle-content">{{ $t('setup253') }}</p>
        <p class="Subtitle-content">{{ $t('setup254') }}</p>
    </div>
    <div class="content">
        <div class="Subtitle-title">
            {{ $t('setup255') }}
        </div>
        <p class="Subtitle-content">{{ $t('setup256') }}</p>
        <p class="Subtitle-content">{{ $t('setup257') }}</p>
        <p class="Subtitle-content">{{ $t('setup258') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup259') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup260') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup261') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup262') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup263') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup264') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup265') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup266') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup267') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup268') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup269') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup270') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup271') }}</p>
        <p class="Subtitle-content">{{ $t('setup272') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup273') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup274') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup275') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup276') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup277') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup278') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup279') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup280') }}</p>
        <p class="Subtitle-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('setup281') }}</p>
        <p class="Subtitle-content">{{ $t('setup282') }}</p>
        <p class="Subtitle-content">{{ $t('setup283') }}</p>
    </div>
    <div class="content">
        <div class="Subtitle-title">
            {{ $t('setup284') }}
        </div>
        <p class="Subtitle-content">{{ $t('setup285') }}</p>
        <p class="Subtitle-content">{{ $t('setup286') }}</p>
       
    </div>
    <div class="content">
        <div class="Subtitle-title">
            {{ $t('setup287') }}
        </div>
        <p class="Subtitle-content">{{ $t('setup288') }}</p>
        <p class="Subtitle-content">{{ $t('setup289') }}</p>
       
    </div>
    <div class="content">
        
        <img src="https://www.9-bill.com/index/img">
       
    </div>
</div>
</div>
</template>
<style scoped lang='scss'>
.container{
    width: 100%;
}
.title{
    // padding-top: 40px;
    color: #282828;
    font-weight: 700;
    font-size: 25px;
    padding-bottom: 16px;
}
.Headline{
    padding: 8px 0px;
    font-size: 18px;
    line-height: 30px;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
}
.content {
    padding: 45px 0;

    .Subtitle-title {
        font-weight: 700;
        font-size: 14px;
        line-height: 30px;
        overflow: hidden;
        color: #131926;
        font-family: Montserrat, Arial, sans-serif;
    }

    .Subtitle-content {
        font-size: 14px;
        line-height: 30px;
        overflow: hidden;
        color: #131926;
        font-family: Montserrat, Arial, sans-serif;

        span {
            font-weight: 700;
        }
    }
}
@media (max-width: 768px) {
    .container{
        width: 100%;
    }
    .content{
        padding-top: 0px;
    }
    .packContent{
        padding: 55px 20px 100px 20px;
        .title{
            display: none;
        }
    }
    .Headline{
    padding: 8px 0px;
    font-size: 16px;
    line-height: 30px;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
}
   
}
</style>